import React from "react";
import {
  Users,
  Boxes,
  Package,
  CheckCircle2,
  PauseCircle,
  AlertTriangle,
  Clock,
  Loader2,
  XCircle,
  RefreshCw,
  Truck,
  ClipboardList,
  Hash,
} from "lucide-react";

export const KPIStatsCards = ({ data }: any) => {
  if (!data) return null;

  const kpiCards = [
    {
      label: "Toplam Görev",
      value: data.totalTasks,
      icon: Hash,
      bgClass: "bg-gray-500/5 text-gray-600 dark:text-gray-300 border-gray-500/10",
    },

    {
      label: "Aktif Çalışan",
      value: data.activeStaffCount,
      icon: Users,
      bgClass: "bg-slate-500/5 text-slate-600 dark:text-slate-400 border-slate-500/10",
    },

    {
      label: "Toplama Bekleyen",
      value: data.pendingPicking,
      icon: Clock,
      bgClass: "bg-blue-500/5 text-blue-600 dark:text-blue-400 border-blue-500/10",
    },

    {
      label: "Toplama Aktif",
      value: data.picking,
      icon: Loader2,
      iconClass: data.picking > 0 ? "animate-spin" : "",
      bgClass: "bg-sky-500/5 text-sky-600 dark:text-sky-400 border-sky-500/10",
    },

    {
      label: "Toplama Duraklatıldı",
      value: data.pickingPaused,
      icon: PauseCircle,
      bgClass:
        data.pickingPaused > 0
          ? "bg-orange-500/10 text-orange-600 dark:text-orange-400 border-orange-500/30"
          : "bg-orange-500/5 text-orange-600 dark:text-orange-400 border-orange-500/10",
    },

    {
      label: "Eksik (Shortage)",
      value: data.shortage,
      icon: AlertTriangle,
      bgClass:
        data.shortage > 0
          ? "bg-red-500/10 text-red-600 dark:text-red-400 border-red-500/30 animate-pulse"
          : "bg-amber-500/5 text-amber-600 dark:text-amber-400 border-amber-500/10",
    },

    {
      label: "Paketleme Bekleyen",
      value: data.pendingPackaging,
      icon: Boxes,
      bgClass: "bg-purple-500/5 text-purple-600 dark:text-purple-400 border-purple-500/10",
    },

    {
      label: "Paketleme Aktif",
      value: data.packaging,
      icon: Package,
      bgClass: "bg-indigo-500/5 text-indigo-600 dark:text-indigo-400 border-indigo-500/10",
    },

    {
      label: "Paketleme Duraklatıldı",
      value: data.packagingPaused,
      icon: PauseCircle,
      bgClass:
        data.packagingPaused > 0
          ? "bg-orange-500/10 text-orange-600 dark:text-orange-400 border-orange-500/30"
          : "bg-orange-500/5 text-orange-600 dark:text-orange-400 border-orange-500/10",
    },

    {
      label: "Tamamlanan",
      value: data.completed,
      icon: CheckCircle2,
      bgClass: "bg-emerald-500/5 text-emerald-600 dark:text-emerald-400 border-emerald-500/20",
    },

      
  ];

  return (<div className="grid grid-cols-1 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-5 xl:grid-cols-10 gap-3 w-full">
      {kpiCards.map((card, index) => {
        const Icon = card.icon;

        return (
          <div
            key={index}
            className={`flex flex-col p-3 rounded-2xl border shadow-sm transition-all duration-200 hover:shadow-md ${card.bgClass}`}
            style={{ backgroundColor: "var(--card)" }}
          >
            <div className="flex items-center justify-between gap-1 mb-2">
              <span className="text-[10px] font-bold opacity-80 uppercase tracking-wider truncate">
                {card.label}
              </span>
              <Icon size={14} className={`shrink-0 ${card.iconClass || "opacity-70"}`} />
            </div>

            <div className="mt-auto pt-1">
              <span
                className="text-xl font-black tracking-tight"
                style={{ color: "var(--text)" }}
              >
                {card.value ?? 0}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
};